export const Sort = {
  Asc: 'asc',
  Desc: 'desc',
} as const
